<div *ngIf="dietPlanFlag == 'min'">
    <div class="details row">
        <div class="col-12" style="margin: 5px 0;">
            <div class="diet_lable_cover">
                <mat-label class="dite_input" [(ngModel)]="cal_txt">
                    Caloried required
                    <span style="float: right;padding: 0 10px 0 0;">{{cal_txt}}</span>
                </mat-label>
                <div class="progress progress-xxs">
                    <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="77"
                        aria-valuemin="0" aria-valuemax="100"
                        [ngStyle]="{'border-bottom':'1px solid green','width':'0'}"></div>
                </div>
            </div>
        </div>
        <div class="col-12" style="margin: 5px 0;">
            <div class="diet_lable_cover">
                <mat-label class="dite_input" [(ngModel)]="tot_cal">
                    Total calories(Kcal)
                    <span style="float: right;padding: 0 10px 0 0;">{{tot_cal}}</span>
                </mat-label>
                <div id="progress"></div>
            </div>
        </div>
        <div class="col-12" style="margin: 5px 0;">
            <div class="diet_lable_cover">
                <mat-label class="dite_input" id="sga" [(ngModel)]="Sga_overalltxt">
                    SGA score
                    <span style="float: right;padding: 0 10px 0 0;">{{(Sga_overalltxt == "") ? 0 :
                        Sga_overalltxt}}</span>
                </mat-label>

                <div class="progress progress-xxs">
                    <div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="23" aria-valuemin="0"
                        aria-valuemax="100" [ngStyle]="{'width':''}"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="dietPlanFlag == 'max'">
    <div class="row">
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4" style="margin: 5px 0;">
            <div class="diet_lable_cover">
                <mat-label class="dite_input">
                    Caloried required
                    <span style="float: right;padding: 0 10px 0 0;">{{cal_txt}}</span>
                </mat-label>
                <div class="progress progress-xxs">
                    <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="77"
                        aria-valuemin="0" aria-valuemax="100"
                        [ngStyle]="{'border-bottom':'1px solid green','width':''}"></div>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4" style="margin: 5px 0;">
            <div class="diet_lable_cover">
                <mat-label class="dite_input">
                    Total calories(Kcal)
                    <span style="float: right;padding: 0 10px 0 0;" id="totalCal">{{tot_cal}}</span>
                </mat-label>
                <div id="progress"></div>
            </div>
        </div>
        <div class="col-9 col-sm-11 col-md-5 col-lg-3 col-xl-3" style="margin: 5px 0;">
            <div class="diet_lable_cover">
                <mat-label class="dite_input" id="sga">
                    SGA score
                    <span style="float: right;padding: 0 10px 0 0;">{{(Sga_overalltxt == "") ? 0 :
                        Sga_overalltxt}}</span>
                </mat-label>

                <div class="progress progress-xxs">
                    <div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="23" aria-valuemin="0"
                        aria-valuemax="100" [ngStyle]="{'width':''}"></div>
                </div>
            </div>
        </div>
        <div class="col-3 col-sm-1 col-md-1 col-lg-1 col-xl-1" style="">
            <img src="../assets/global/images/settings-icon.png" (click)="openDietPlan()" class=""
                style="position: relative;top: 8px;" width="22px" height="22px" />
        </div>
       
        <div class="dite_content_cover">
            <div class="row">
                <div class="col-4">
                    <mat-label class="matlabel" style="font-size: 15px; font-weight: 600;">&nbsp;</mat-label><br>
                    <div class="switch-field" *ngIf="ynopt1 != undefined" >
                        <input type="radio" id="radio-three" (click)="change_type(1,'yes')" [disabled]="!currentDiet" />
                        <label for="radio-three" [ngClass]="ynopt1 ? 'radio_active':'radio_inactive'">
                            <div class="tab_cover">
                                <div class="tab_icon_cover"><img src="../../../assets/ui_icons/Self.svg"
                                        class="iocinStyle" alt=""></div>
                                <div class="lableStyle">Current</div>
                            </div>
                        </label>
                        <input type="radio" id="radio-four" (click)="change_type(1,'no')" [disabled]="!templateDiet" />
                        <label for="radio-four" [ngClass]="!ynopt1 ? 'radio_active':'radio_inactive'">
                            <div class="tab_cover">
                                <div class="tab_icon_cover"><img src="../../../assets/ui_icons/others.svg"
                                        class="iocinStyle" alt=""></div>
                                <div class="lableStyle">Suggested diet</div>
                            </div>
                        </label>
                    </div>
                </div>
                <div class="col-12 col-sm-4 col-md-3 col-xl-2 col-lg-2">
                    <mat-label class="matlabel" style="font-size: 15px; font-weight: 600;">Range</mat-label><br>
                    <select disableOptionCentering class="ipcss" (change)="changeAppointmentType()"
                        [(ngModel)]="appointmentType">
                        <!-- <option value="Today">Today</option> -->
                        <option value="Weekly">Weekly</option>
                        <option value="Fort Night">Fort Night</option>
                        <option value="Monthly">Monthly</option>
                        <option value="3 Months">3 Months</option>
                        <option value="6 Months">6 Months</option>
                        <option value="Yearly">Yearly</option>
                        <option value="Date">Date</option>
                    </select>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2 select_bottom" *ngIf="dateFlag">
                    <mat-label class="matlabel">From<br>
                        <input type="date" class="ipcss widthbilllist datecss" (change)="selectFromDate(fromDate)"
                            [(ngModel)]="fromDate" #matInput max="{{currentDate}}">
                    </mat-label>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2" *ngIf="dateFlag">
                    <mat-label class="matlabel">To<br>
                        <input type="date" class="ipcss widthbilllist datecss" id="appt_date"
                            (change)="selectToDate(toDate)" [(ngModel)]="toDate" max="{{currentDate}}" matInput>
                    </mat-label>
                </div>
            </div>
            <div>
                <img *ngIf="previousFlag && displayArray.length != 0" src="../../../assets/ui_icons/diet_plan/Previous_icon.svg"
                    (click)="copyDietPlan('previous')" style="left: 8px;z-index: 2;" class="navIcon" alt="">
                <img *ngIf="nextFlag && displayArray.length != 0" src="../../../assets/ui_icons/diet_plan/Next_icon.svg"
                    style="right: 8px;" class="navIcon" alt="" (click)="copyDietPlan('next')">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <ng-container *ngFor="let person of displayArray; let i = index">
                        <li class="nav-item" role="presentation" *ngIf="person.weekNo == week" >
                            <button class="nav-link" id="{{person.date}}-tab" data-bs-toggle="tab" 
                            attr.data-bs-target="#{{person.day}}" type="button" role="tab" 
                            attr.aria-controls="{{person.day}}" aria-selected="true" 
                            (click)="dayClick(person.day,person.date,true)">{{person.date | date:'dd-MM-yyyy'}} <br> ({{person.dayLable}}) </button>
                        </li>
                    </ng-container>
                </ul>
            </div>
            
            <div class="tab-content" id="myTabContent">
                <div *ngFor="let person1 of showArray" style="height: 485px; overflow-y: auto;  overflow-x: hidden;">
                    <div class="row" *ngFor="let session of person1.session;" style="margin-top: 10px;">
                        <div class="col-8 col-sm-7 col-md-12 col-lg-4 col-xl-4">
                            <div class="card cardCover">
                                <div class="card-header cardHeader">
                                    {{session.lableName}}
                                    <span style="float: right;">
                                        {{session.energy}} Kcal
                                    </span>
                                </div>
                                <div class="card-body">
                                    <div *ngIf="session.type == 'Morning'">
                                        <mat-label class="matlabel">Add food item <br>
                                            <input type="text" class="ipcss mainDishInput" [(ngModel)]="morningFoods"
                                                name="morningFoods" (keyup)="foottype(morningFoods, session.type)"
                                                type="text" aria-label="Number" matInput
                                                [matAutocomplete]="autoMorning" />
                                            <div style="display: inline-block;">
                                                <img *ngIf="session.mainDish == true"
                                                    src="../../../assets/ui_icons/main_course_green_icon.png"
                                                    height="20px" alt="" class="mainDishImg">
                                                <img *ngIf="session.mainDish == false"
                                                    (click)="mainDish(session,person1.day)"
                                                    src="../../../assets/ui_icons/main_course_blue_icon.png"
                                                    height="20px" alt="" class="mainDishImg">
                                            </div>
                                            <mat-autocomplete #autoMorning="matAutocomplete">
                                                <mat-option id="optionfont" (click)="selctedFood(person1.day,person1.date,food)"
                                                    *ngFor="let food of morningFoodItem" [value]="food.description">
                                                    {{food.displayContent}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-label>
                                    </div>
                                    <div *ngIf="session.type == 'Breakfast'">
                                        <mat-label class="matlabel">Add food item</mat-label><br>
                                        <input type="text" class="ipcss mainDishInput" [(ngModel)]="BreakfastFoods"
                                            name="BreakfastFoods" (keyup)="foottype(BreakfastFoods, session.type)"
                                            type="text" aria-label="Number" matInput
                                            [matAutocomplete]="autoBreakfast" />
                                        <div style="display: inline-block;">
                                            <img *ngIf="session.mainDish == true"
                                                src="../../../assets/ui_icons/main_course_green_icon.png" height="20px"
                                                alt="" class="mainDishImg">
                                            <img *ngIf="session.mainDish == false"
                                                (click)="mainDish(session,person1.day)"
                                                src="../../../assets/ui_icons/main_course_blue_icon.png" height="20px"
                                                alt="" class="mainDishImg">
                                        </div>
                                        <mat-autocomplete #autoBreakfast="matAutocomplete">
                                            <mat-option id="optionfont" (click)="selctedFood(person1.day,person1.date,food)"
                                                *ngFor="let food of breadfastFoodItem" [value]="food.description">
                                                {{food.displayContent}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </div>
                                    <div *ngIf="session.type == 'Mid-day'">
                                        <mat-label class="matlabel">Add food item</mat-label><br>
                                        <input type="text" class="ipcss mainDishInput" [(ngModel)]="MidDayFoods"
                                            name="MidDayFoods" (keyup)="foottype(MidDayFoods, session.type)" type="text"
                                            aria-label="Number" matInput [matAutocomplete]="autoMidDay" />
                                        <div style="display: inline-block;">
                                            <img *ngIf="session.mainDish == true"
                                                src="../../../assets/ui_icons/main_course_green_icon.png" height="20px"
                                                alt="" class="mainDishImg">
                                            <img *ngIf="session.mainDish == false"
                                                (click)="mainDish(session,person1.day)"
                                                src="../../../assets/ui_icons/main_course_blue_icon.png" height="20px"
                                                alt="" class="mainDishImg">
                                        </div>
                                        <mat-autocomplete #autoMidDay="matAutocomplete">
                                            <mat-option id="optionfont" (click)="selctedFood(person1.day,person1.date,food)"
                                                *ngFor="let food of midDayFoodItem" [value]="food.description">
                                                {{food.displayContent}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </div>
                                    <div *ngIf="session.type == 'Lunch'">
                                        <mat-label class="matlabel">Add food item</mat-label><br>
                                        <input type="text" class="ipcss mainDishInput" [(ngModel)]="LunchFoods"
                                            name="LunchFoods" (keyup)="foottype(LunchFoods, session.type)" type="text"
                                            aria-label="Number" matInput [matAutocomplete]="autoLunchFoods" />
                                        <div style="display: inline-block;">
                                            <img *ngIf="session.mainDish == true"
                                                src="../../../assets/ui_icons/main_course_green_icon.png" height="20px"
                                                alt="" class="mainDishImg">
                                            <img *ngIf="session.mainDish == false"
                                                (click)="mainDish(session,person1.day)"
                                                src="../../../assets/ui_icons/main_course_blue_icon.png" height="20px"
                                                alt="" class="mainDishImg">
                                        </div>
                                        <mat-autocomplete #autoLunchFoods="matAutocomplete">
                                            <mat-option id="optionfont" (click)="selctedFood(person1.day,person1.date,food)"
                                                *ngFor="let food of lunchFoodItem" [value]="food.description">
                                                {{food.displayContent}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </div>
                                    <div *ngIf="session.type == 'Evening'">
                                        <mat-label class="matlabel">Add food item</mat-label><br>
                                        <input type="text" class="ipcss mainDishInput" [(ngModel)]="EveningFoods"
                                            name="EveningFoods" (keyup)="foottype(EveningFoods, session.type)"
                                            type="text" aria-label="Number" matInput
                                            [matAutocomplete]="autoEveningFoods" />
                                        <div style="display: inline-block;">
                                            <img *ngIf="session.mainDish == true"
                                                src="../../../assets/ui_icons/main_course_green_icon.png" height="20px"
                                                alt="" class="mainDishImg">
                                            <img *ngIf="session.mainDish == false"
                                                (click)="mainDish(session,person1.day)"
                                                src="../../../assets/ui_icons/main_course_blue_icon.png" height="20px"
                                                alt="" class="mainDishImg">
                                        </div>
                                        <mat-autocomplete #autoEveningFoods="matAutocomplete">
                                            <mat-option id="optionfont" (click)="selctedFood(person1.day,person1.date,food)"
                                                *ngFor="let food of eveningFoodItem" [value]="food.description">
                                                {{food.displayContent}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </div>
                                    <div *ngIf="session.type == 'Dinner'">
                                        <mat-label class="matlabel">Add food item</mat-label><br>
                                        <input type="text" class="ipcss mainDishInput" [(ngModel)]="DinnerFoods"
                                            name="DinnerFoods" (keyup)="foottype(DinnerFoods, session.type)" type="text"
                                            aria-label="Number" matInput [matAutocomplete]="autoDinnerFoods" />
                                        <div style="display: inline-block;">
                                            <img *ngIf="session.mainDish == true"
                                                src="../../../assets/ui_icons/main_course_green_icon.png" height="20px"
                                                alt="" class="mainDishImg">
                                            <img *ngIf="session.mainDish == false"
                                                (click)="mainDish(session,person1.day)"
                                                src="../../../assets/ui_icons/main_course_blue_icon.png" height="20px"
                                                alt="" class="mainDishImg">
                                        </div>
                                        <mat-autocomplete #autoDinnerFoods="matAutocomplete">
                                            <mat-option id="optionfont" (click)="selctedFood(person1.day,person1.date,food)"
                                                *ngFor="let food of dinnerFoodItem" [value]="food.description">
                                                {{food.displayContent}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </div>
                                    <div *ngIf="session.type == 'Night'">
                                        <mat-label class="matlabel">Add food item</mat-label><br>
                                        <input type="text" class="ipcss mainDishInput" [(ngModel)]="NightFoods"
                                            name="NightFoods" (keyup)="foottype(NightFoods, session.type)" type="text"
                                            aria-label="Number" matInput [matAutocomplete]="autoNightFoods" />
                                        <div style="display: inline-block;">
                                            <img *ngIf="session.mainDish == true"
                                                src="../../../assets/ui_icons/main_course_green_icon.png" height="20px"
                                                alt="" class="mainDishImg">
                                            <img *ngIf="session.mainDish == false"
                                                (click)="mainDish(session,person1.day)"
                                                src="../../../assets/ui_icons/main_course_blue_icon.png" height="20px"
                                                alt="" class="mainDishImg">
                                        </div>
                                        <mat-autocomplete #autoNightFoods="matAutocomplete">
                                            <mat-option id="optionfont" (click)="selctedFood(person1.day,person1.date,food)"
                                                *ngFor="let food of nightFoodItem" [value]="food.description">
                                                {{food.displayContent}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </div>
                                    <div class="foodItemCover">
                                        <div *ngFor="let foodList of session.foodItems" class="foodItemsInnerCover">
                                            <span class="foodItemsSpan" style="vertical-align: top;">
                                                <img *ngIf="foodList.checked == false"
                                                    (click)="isSelected(foodList,'add')"
                                                    src="../../../assets/ui_icons/yellow_box.svg"
                                                    style="cursor: pointer;" width="15px" />

                                                <img *ngIf="foodList.checked == true"
                                                    (click)="isSelected(foodList,'remove')"
                                                    src="../../../assets/ui_icons/popup_tick_mark.svg"
                                                    style="cursor: pointer;" width="15px" />
                                            </span>
                                            <div class="foodLable"> {{ foodList.description }} </div>
                                            <div class="foodInputCover"> <input type="text"
                                                    (blur)="changequantity(foodList.cals_weight,foodList.day,foodList,session.type)"
                                                    [(ngModel)]="foodList.cals_weight" class="foodMesureInput"
                                                    [disabled]="!foodList.checked" maxlength="4"
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                                                <div class="foodMeasure">{{foodList.wightMesure}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 ">
                            <div class="row foodItemsCover">
                                <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 p-0"
                                    style="display: flex;align-items: center;justify-content: center;">
                                    <div class="plateCover">
                                        <div id="{{person1.date}}_{{session.type}}" class="main"
                                            [innerHTML]="session.plateContent">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-6 col-lg-8 col-xl-8 p-0 my-auto"
                                    style="hight:fit-content">
                                    <div class="foodValues">
                                        <div style="width: 584px;">
                                            <div class="foodItems"> <span> Energy (Kcal)</span> <br>
                                                <span>{{session.energy}}</span>
                                            </div>
                                            <div class="foodItems"> <span> Protien (gm)</span> <br>
                                                <span>{{session.Protien}}</span>
                                            </div>
                                            <div class="foodItems"> <span> Calcium (mg)</span> <br>
                                                <span>{{session.Ca}}</span>
                                            </div>
                                            <div class="foodItems"> <span> Iron (mg)</span> <br>
                                                <span>{{session.Fe}}</span>
                                            </div>
                                            <div class="foodItems"> <span> Fiber (mg)</span> <br>
                                                <span>{{session.fiber}}</span>
                                            </div>
                                            <div class="foodItems"> <span> Vit A (mg)</span> <br>
                                                <span>{{session.vaitamina}}</span>
                                            </div>
                                            <hr />
                                            <div class="foodItems"> <span> Fat (gm)</span> <br>
                                                <span>{{session.Fat}}</span>
                                            </div>
                                            <div class="foodItems"> <span> H<sub>2</sub>O (gm)</span>
                                                <br>
                                                <span>{{session.h2o}}</span>
                                            </div>
                                            <div class="foodItems"> <span> Folic (mcg)</span> <br>
                                                <span>{{session.Folic}}</span>
                                            </div>
                                            <div class="foodItems"> <span> Carbos (mg)</span> <br>
                                                <span>{{session.Carbohydrates}}</span>
                                            </div>
                                            <div class="foodItems"> <span> Vit C (mg)</span> <br>
                                                <span>{{session.Vitaminc}}</span>
                                            </div>
                                            <div class="foodItems"> <span> Vit B12 (mg)</span> <br>
                                                <span>{{session.vitaminb12}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a (click)="dietplanhistory('diettracker')"><img src="../../../assets/ui_icons/buttons/history.svg"
                        class="saveimgbtn_inpatinfo" /></a>
                    <a (click)="dietplanhistory('patient')"><img src="../../../assets/ui_icons/buttons/wrong.svg"
                        class="saveimgbtn_inpatinfo" /></a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="titleStyle">
                <h5 class="modal-title" id="staticBackdropLabel">Diet Conformation</h5>
                <span class="closeicon" data-bs-dismiss="modal" aria-label="Close" style="float: right;"><img
                        src="../../../assets/img/close_icon.png" alt="Card image cap" style="width:19px"> </span>
            </div>
            <div class="modal-body">
                Whould you like to copy {{selctedDay}} diet plan to other days?
            </div>
            <div class="modal-footer">
                <img src="../../../assets/ui_icons/buttons/No_button.svg" alt="Card image cap"
                    style="width:85px; height: 25px;" (click)="assingData('no')">
                <img src="../../../assets/ui_icons/buttons/yes_button.svg" alt="Card image cap"
                    style="width:85px; height: 25px;" (click)="assingData('yes')">
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="pdfModel" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" *mgIf="pdfFlag">
    <div class="modal-dialog " style="width: 950px; max-width: 950px;">
        <div class="modal-content">
            <div class="modal-body">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8" style="margin-top: 10px;">
                    <iframe class="controls" [src]="pdfURL" width="900px" height="700px" frameborder="0" webkitallowfullscreen
                      mozallowfullscreen allowfullscreen></iframe>
                  </div>
            </div>
        </div>
    </div>
</div>